import React from 'react';

import {useLegalInfo} from 'pageflow-scrolled/frontend';

import styles from './Footer.module.css';

import logo from './images/bvz.jpg';
import facebookImage from './images/facebook.jpg';
import instagramImage from './images/instagram.jpg';
import tiktiokImage from './images/tiktok.jpg';

export function BvzFooter({name}) {
  const legalInfo = useLegalInfo();

  return (
    <div className={styles.outer}>
      <div className={styles.bar}>
        <a href="https://www.bvz.at/">
          <img src={logo} className={styles.logo} alt="BVZ" width="164" height="86" />
        </a>
        <div className={styles.back}>
          <a href="https://www.bvz.at/">zurück zu BVZ.at</a>
        </div>

        <div className={styles.social}>
          <a href="https://www.facebook.com/bvzat/?locale=de_DE" title="BVZ.at auf Facebook">
            <img src={facebookImage} alt="Facebook" width="40" height="40" />
          </a>
          <a href="https://www.instagram.com/bvz.at/?hl=de" title="BVZ.at auf Instagram">
            <img src={instagramImage} alt="Instagram" width="40" height="40" />
          </a>
          <a href="https://www.tiktok.com/@bvz.at" title="BVZ.at auf TikTok">
            <img src={tiktiokImage} alt="TikTok" width="40" height="40" />
          </a>
        </div>
        <div className={styles.finePrint}>
          BVZ Burgenländische Volkszeitung GmbH<br />
          Colmarplatz 1/2. Stock, 7000 Eisenstadt
        </div>

        <div className={styles.links}>
          <a href={legalInfo.imprint.url}
             target="_blank"
             rel="noreferrer noopener"
             dangerouslySetInnerHTML={{__html: legalInfo.imprint.label}} />
          <a href={legalInfo.privacy.url}
             target="_blank"
             rel="noreferrer noopener"
             dangerouslySetInnerHTML={{__html: legalInfo.privacy.label}} />
        </div>
      </div>
    </div>
  )
}
